module.exports = __webpack_public_path__ + "static/img/buildsucesse.7ec0eefb.png";